import React from 'react';
import BrandAutocomplete from '.';

function EnumAutocomplete({
  onChange,
  value,
  name,
  label,
  placeholder,
  ENUM = [],
  size,
  noLabel,
  multiple,
  disabled,
  lg,
  md
}) {
  const options = ENUM.map((option) => ({
    label: option,
    value: option
  }));
  return (
    <BrandAutocomplete
      size={size ?? 'medium'}
      label={label ?? 'ENUM Select'}
      noLabel={noLabel}
      placeholder={placeholder ?? 'Select value...'}
      onChange={onChange}
      value={value}
      name={name ?? 'enumSelect'}
      options={options}
      lg={lg}
      md={md}
      multiple={multiple}
      disabled={disabled}
    />
  );
}

export default EnumAutocomplete;
